import GetBonusRulesRequestService from '@bto-services/api/shared/get-bonus-rules-request-service';
import { setAccumulatorBonus, removeBetslipMessage, calculateBonuses } from '@bto-services/betslip-core';
import { userLoggedIn } from '@bto-services/user';
import { BETSLIP_MESSAGE_KEY } from 'bto-models/betslip';
/**
 * Vuex store - user module
 */
export const UserModule = {
  state: {
    player: APP_SETTINGS && APP_SETTINGS.player ? { ...APP_SETTINGS.player } : {},
    pUniqueKey: 1,
  },
  mutations: {
    setPlayer(state, newPlayer) {
      state.player = {
        ...state.player,
        ...newPlayer
      };
      APP_SETTINGS.player = {
        ...state.player
      };
      state.pUniqueKey += 1;
    }
  },
  actions: {
    login({ commit, dispatch }, newPlayer) {
      commit('setPlayer', newPlayer);
      dispatch('setUserState');
      dispatch('getPlayerInfo');
    },
    logout({ commit, dispatch }) {
      commit('setPlayer', {
        id: "",
        token: "",
        currency: "",
      });
      dispatch('setUserState');
    },
    setUserState({ dispatch }) {
      if (!userLoggedIn()) {
        new GetBonusRulesRequestService().execute((resp) => {
          if (resp.data) {
            setAccumulatorBonus(resp.data);
          }
        });
      }
      dispatch('clearPlayerData');
    },
    clearPlayerData({ commit }) {
      commit('addMyBets', []);
      commit('addCashoutBets', []);
      commit('resetNegotiations');
      removeBetslipMessage(BETSLIP_MESSAGE_KEY.LOGIN);
      calculateBonuses();
    }
  },
  getters: {
    getPlayer(state) {
      return state.player;
    },
    isUserLogged(state) {
      return state.player && state.player.token && state.player.id;
    }
  },
};
